export default __webpack_public_path__ + "static/media/hyundai.89a7f601.webp";